import register from './register-service-worker';

export default register;
export { unregister } from './register-service-worker';
